import React, { useEffect, useState } from "react";
import Header from "./Base/Header";
import { ToastContainer } from "react-toastify";
import useCurrentPath from "./Base/Hooks/usetCurrentPath";
import useSignature from "./utils/hooks/useSignature";
import Router from "./Router";
import SwitchModal from "./Base/SwitchModal";
import "react-toastify/dist/ReactToastify.css";
import useWalletConnect from "./utils/hooks/useWalletConnect";
import { fetchWalletSettings } from "./redux/wallet/action";
import { useDispatch, useSelector } from "react-redux";
import useCustomToast from "./utils/hooks/useToast";
import { useNavigate } from "react-router-dom";
import { getWalletDetails } from "./redux/wallet/api";
import { setSignature } from "./redux/user/action";
import { NETWORKS_MAINNET, NETWORKS_TESTNET } from "./utils/constants";
import { isMainNet } from "./utils/config";

export default function App() {
  const { account, isConnected, chain } = useWalletConnect();
  const { generateSignature, getAuth } = useSignature();
  const { signature, nonce } = useSelector(({ user }) => user);
  const { walletSettings } = useSelector(({ wallet }) => wallet);
  const { showToast } = useCustomToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modal, setModal] = useState(null);

  useEffect(() => {
    const bscChainId =
      isMainNet === "true" ? NETWORKS_MAINNET["BSC"] : NETWORKS_TESTNET["BSC"];

    if (isConnected && chain?.id && chain?.id != bscChainId) {
      setModal("switch");
    }
  }, [isConnected]);

  useEffect(() => {
    const bscChainId =
      isMainNet === "true" ? NETWORKS_MAINNET["BSC"] : NETWORKS_TESTNET["BSC"];

    if (isConnected && chain?.id && chain?.id == bscChainId) {
      setModal(null);
    }
  }, [chain?.id]);

  useEffect(() => {
    const localStorageSignature = localStorage.getItem("signature");
    if (!!localStorageSignature) {
      dispatch(setSignature(localStorageSignature));
    }

    if (!!account && !!signature && isConnected) {
      const payload = {
        $auth: getAuth,
      };
      getWalletDetails(payload)
        .then((response) => {
          const isNewUser = Object.values(response).every(
            (res) => res.accepted == false
          );
          if (isNewUser) {
            showToast(`Please configure the wallets.`, "info");
            navigate("/dashboard/wallets");
          }
        })
        .catch((e) => console.log(e));
    }

    if (isConnected && !!account && signature == "") {
      const timer = setTimeout(() => {
        generateSignature();
      }, 1000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isConnected, account, signature]);

  const dashHeader = useCurrentPath({
    routes: ["landing"],
  });

  return (
    <>
      {!dashHeader && <Header />}
      <div className={!dashHeader && "wrapper"}>
        <Router />
        {modal === "switch" && (
          <SwitchModal
            onClose={() => {
              setModal(null);
            }}
          />
        )}
      </div>
      <ToastContainer />
    </>
  );
}
